{
    "button.copy": "Copiar",
    "button.email": "Correo electrónico",
    "button.share": "Cuota",
    "button.sms": "SMS",
    "footer.poweredBy": "Desarrollado por <linkText>Ice Cream Social<\/linkText>",
    "footer.privacyPolicy": "Política de privacidad",
    "footer.termsAndConditions": "Términos y condiciones",
    "offer.hint": "Cuando {conversionGoal, plural, one {# amigo hace una compra } two {# amigos hacen compras } few {# amigos hacen compras } many {# amigos hacen compras } other {# amigos hacen compras }}, recibirás tu recompensa",
    "optInMessage": "Para participar y compartir con sus amigos, háganos saber cómo contactarlo con actualizaciones de ofertas y recompensas",
    "order.confirmed": "¡Orden # {orderId} confirmada!",
    "order.details": "Ver detalles del pedido",
    "share.email.duplicateError": "¡Vaya! Ya agregaste ese correo electrónico.",
    "share.email.heading": "Invitar amigos por correo electrónico",
    "share.email.inputLabel": "Dirección de e-mail de un amigo",
    "share.email.inputSubmit": "Ingresar",
    "share.email.invitesSubmit": "Enviar invitaciones",
    "share.email.moreOptions": "Más opciones para compartir",
    "share.email.subheading": "Ingrese las direcciones de correo electrónico de sus amigos a continuación",
    "share.general.help": "<bold> ¿Tienes problemas? <\/bold> Es posible que las aplicaciones no se abran si no están instaladas en su dispositivo, intente usar <bold2> Compartir <\/bold2> con su enlace personal en su lugar",
    "share.general.linkLabel": "Usa tu enlace personal para compartir en cualquier lugar",
    "share.general.otherOptions": "O comparte ahora en estas plataformas",
    "thankyou.dismissCTA": "Despedir",
    "thankyou.heading": "¡Gracias por compartir!",
    "thankyou.message": "¡Eres un campeón! Le enviaremos actualizaciones sobre el progreso de su recompensa a su bandeja de entrada.",
    "thankyou.reminder": "Tenga en cuenta que siempre puede volver a visitar esta oferta más tarde si desea continuar compartiendo.",
    "thankyou.shareCTA": "Continuar compartiendo",
    "unlock.consentExplanation": "Nos pondremos en contacto con la información que proporcionó. Puede darse de baja en cualquier momento, pero es posible que se pierda las actualizaciones sobre su oferta",
    "unlock.consentPolicyExplanation": "Valoramos su privacidad. Para saber cómo se utiliza su información, lea nuestra <linkText> Política de privacidad y cookies <\/linkText>",
    "unlock.emailConsentOptIn": "Enviarme actualizaciones por correo electrónico",
    "unlock.error.invalidEmail": "Por favor introduzca una dirección de correo electrónico válida",
    "unlock.error.noConsent": "Por favor, acepte las comunicaciones por correo electrónico para participar en esta oferta.",
    "unlock.input": "Su dirección de correo electrónico",
    "unlock.label": "Activar oferta",
    "share.general.copySuccess": "✨ ¡Enlace copiado!"
}